import React from 'react';
import { Icon } from '../../icons';
import './Banner.css';

export type BannerVariant = 'info' | 'warning' | 'failure' | 'success';

export interface BannerProps {
  variant?: BannerVariant;
  title?: string;
  children: React.ReactNode;
  className?: string;
  margin?: string;
  padding?: string;
  ariaLabel?: string;
}

export const Banner = React.memo(function Banner({
  variant = 'info',
  title,
  children,
  className,
  margin,
  padding,
  ariaLabel,
}: BannerProps) {
  const iconMap: Record<BannerVariant, 'Info' | 'AlertTriangle' | 'AlertCircle' | 'CheckCircle'> = {
    info: 'Info',
    warning: 'AlertTriangle',
    failure: 'AlertCircle',
    success: 'CheckCircle',
  };
  const iconName = iconMap[variant] ?? 'Info';

  const style: React.CSSProperties = {};
  if (margin) style.margin = margin;
  if (padding) style.padding = padding;

  return (
    <div
      className={`banner ${className || ''}`.trim()}
      data-variant={variant}
      style={style}
      aria-label={ariaLabel}
    >
      <div className="banner__icon">
        <Icon name={iconName} size={20} />
      </div>
      <div className="banner__content">
        {title && <div className="banner__title">{title}</div>}
        <div className="banner__description">{children}</div>
      </div>
    </div>
  );
});
